import React from "react";

function Hero() {
  return (
    <div className="container border-bottom p-3">
      <div className="row text-center mt-5 mb-5">
        <h1>Technology</h1>
        <h3 className="text-muted mt-3 fs-4">
          Sleek, modern and intuitive trading platforms
        </h3>
        <p className="mt-3">
          Check out our{" "}
          <a href="" style={{ textDecoration: "none" }}>
            investment offerings <i class="fa-solid fa-right-long"></i>
          </a>
        </p>
      </div>
    </div>
  );
}

export default Hero;
